import axios from "axios";

import { authApi } from "../../utils/axios";
import { config } from "../../utils/config";
import { getUpcomingDate } from "../../utils/helpers";
import SPORT_TYPES from "../../utils/sportTypes";

export async function createPracticeEvent(user, access, team, teamId, onSuccess, onFail) {
    try {

        const day = team?.eventDays[0]
        const hour = team?.eventTime?.from?.hr
        const minute = team?.eventTime?.from?.min

        const eventStartDate = getUpcomingDate(day, hour, minute);

        let teams = [teamId];
        let body = {
          sportType: SPORT_TYPES.FOOTBALL,
          eventType: "training",
          teams,
          status: "published",
          recurring: {
            startDate: eventStartDate,
            onEvery: 'week',
            totalEvents: 2
            },
          invitedPlayers: [{team: teamId, players: [user?.user?.id],}]
        };  

        const accessToken = access?.token
        const headers = {
            'Authorization': `Bearer ${accessToken}`
        }

        const response = await axios({
            method: 'post',
            url: `${config.API_BASE_URL}/event/register`,
            data: body,
            headers: headers,
            encoding: null
        })

        if (typeof onSuccess === 'function') onSuccess(response?.data)

    }
    catch(err){
        if (typeof onFail === 'function') onFail(err)
    }
}

export async function updateTeamImage(team, teamId, access, onSuccess, onFail) {
    try {   

        const crest = team?.crest

        const formData = new FormData();
        formData.append('files', crest)

        const accessToken = access?.token
        const headers = {
            'Authorization': `Bearer ${accessToken}`
        }
        
        const resp = await axios({
            method: 'post',
            url: `${config.API_BASE_URL}/files/upload?purpose=teamImg&teamId=${teamId}`,
            data: formData,
            headers: headers,
        })

        const body = {
            crest: resp?.data[0]?.s3Url
        }

        await axios({
            method: 'put',
            url: `${config.API_BASE_URL}/teams/${teamId}`,
            data: body,
            headers: headers,
            encoding: null
        })

        if (typeof onSuccess === 'function') onSuccess()
    }
    
    catch (err) {
        if (typeof onFail === 'function') onFail()
    }
}

export async function getLocationInfo(accessToken, latitude, longitude) {
    try{

        const headers = {
            'Authorization': `Bearer ${accessToken}`
        }

        const response = await authApi({
            method: 'get',
            url: `${config.API_BASE_URL}/location-entity/location-info`,
            params: {latitude: latitude, longitude: longitude},
            headers: headers,
            encoding: null
        })
        
        if (response.data?.results?.length > 0) {
            return response.data.results[0]
        } 
        else {
            return null
        }
    }
    catch(err){
        return null
    }
    
}

export async function createTeam (email, team, sport, access, onSuccess, onFail) {
    try {
        
        const accessToken = access?.token

        const locationResults = await getLocationInfo(accessToken, team?.location?.lat, team?.location?.long)
        const location = {
            latitude: team?.location?.lat,
            longitude: team?.location?.long,
            addressComponents: locationResults?.address_components
        }

        const body = {
            title: team?.name,
            ...(team?.bio.length > 0 && { description: team?.bio }),
            sport: sport?.name,
            ...(location && { geolocation: location }),
            email: email?.name,
        }

        const headers = {
            'Authorization': `Bearer ${accessToken}`
        }
        
        const response = await authApi({
            method: 'post',
            url: `${config.API_BASE_URL}/teams/clubless-register-team-with-members`,
            data: body,
            headers: headers,
            encoding: null
        })

        if (typeof onSuccess === 'function') onSuccess(response?.data)
    }

    catch (err) {
        if (typeof onFail === 'function') onFail(err?.response?.status)
    }
}

/**
 * Create a custom team with name and email
 * Backend should create team and return { id, title, email, ... }
 */
export const createCustomTeam = async ({ title, email, sport }) => {
  const response = await authApi({
    method: "POST",
    url: `/teams/create-tournament-placeholder-team`,
    data: { title, email, sport },
  });
  return response.data;
};

export const searchTeams = async (params) => {
  const { query, sportType } = params;
  const queryParams = new URLSearchParams({
    query,
    ...(sportType && { sportType }),
  });

  const response = await authApi({
    method: "GET",
    url: `/teams/search?${queryParams}`,
  });
  return response.data;
};

export const updateTeam = async (teamId, teamData) => {
  const response = await authApi({
    method: "PUT",
    url: `/teams/${teamId}`,
    data: teamData,
  });
  return response.data;
};

export const inviteTeam = async (
  tournamentId,
  categoryId,
  teamData
) => {
  const response = await authApi({
    method: "POST",
    url: `/tournaments/${tournamentId}/categories/${categoryId}/teams/invite`,
    data: teamData,
  });
  return response.data;
};

export const deleteTeam = async (
  tournamentId,
  categoryId,
  teamId,
  fullyDelete = true
) => {
  const response = await authApi({
    method: "DELETE",
    url: `/tournaments/${tournamentId}/categories/${categoryId}/teams/${teamId}?deleteTeam=${fullyDelete}`,
  });
  return response.data;
};

export const getAllTeams = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams({
      ...params,
    });

    const response = await authApi({
      method: "GET",
      url: `/teams?${queryParams}`,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getTeamById = async (teamId) => {
  const response = await authApi({
    method: "GET",
    url: `/teams/${teamId}/team-dashboard`,
  });
  return response.data;
};

export const getTeamStats = async (teamId) => {
  const response = await authApi({
    method: "GET",
    url: `/teams/${teamId}/team-stats`,
  });
  return response.data;
};

export const getTeamOverview = async (teamId, data) => {
  const response = await authApi({
    method: "POST",
    url: `/teams/${teamId}/overview`,
    data,
  });
  return response.data;
};
